import React from "react";
import { InfoWindow } from "@vis.gl/react-google-maps";
import { mapInfoImage } from "assets";
import { LAST_UPDATED_TIME } from "../../../constants";
import { LocationInfoWindowProps } from "type";

const LocationInfoWindow: React.FC<LocationInfoWindowProps> = React.memo(
  ({ anchor, isOpen, onClose, locationName, loading, error, timestamp }) => {
    if (!isOpen || !anchor) {
      return null;
    }

    return (
      <InfoWindow anchor={anchor} maxWidth={300} onCloseClick={onClose}>
        <div
          style={{
            padding: "var(--spacing-lg)",
            borderRadius: "var(--border-radius-md)",
            background: "var(--bg-info-window-gradient)",
            display: "flex",
            gap: "var(--spacing-sm)",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div>
            <img
              src={mapInfoImage}
              alt="info"
              style={{
                width: "var(--icon-size-sm)",
                height: "var(--icon-size-sm)",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              letterSpacing: "var(--letter-spacing-geo-coding)",
            }}
          >
            <div style={{ marginBottom: "5.8px" }}>
              <div
                style={{
                  color: "var(--color-text-primary)",
                  fontWeight: "var(--font-weight-medium)",
                  fontSize: "var(--font-size-md)",
                  lineHeight: "var(--line-height-geo-coding)",
                }}
              >
                {loading
                  ? "Loading location..."
                  : locationName || "Click to load location"}
              </div>
              {error && (
                <p
                  style={{
                    color: "var(--color-error)",
                  }}
                >
                  {error}
                </p>
              )}
            </div>
            <div
              style={{
                color: "var(--info-accent-color)",
                fontWeight: "var(--font-weight-normal)",
                fontSize: "var(--font-size-sm)",
                marginBottom: "3.5px",
              }}
            >
              {LAST_UPDATED_TIME}
            </div>
            <div
              style={{
                color: "var(--color-text-primary)",
                fontWeight: "var(--font-weight-medium)",
                fontSize: "var(--font-size-md)",
              }}
            >
              {timestamp}
            </div>
          </div>
        </div>
      </InfoWindow>
    );
  }
);

LocationInfoWindow.displayName = "LocationInfoWindow";

export default LocationInfoWindow;
